module.exports = __webpack_public_path__ + "6dcdb2957987574d20f628d8c8f33066.pdf";